import {FilterListForm} from 'common/pages/filter-list/FilterListForm'

export const FilterListFormAgency = (props) =>
    <FilterListForm {...props} mode={props.mode} agency />